import { Routes, Route } from 'react-router-dom';
import MargemBrutaPercentual from '../pages/margemBrutaPercentual';
import MargemBruta from '../pages/margemBruta';
import SalariosPorProjeto from '../pages/salariosPorProjeto';
import CustosPorProjeto from '../pages/lancamentos';
import SimuladorFolha from '../pages/simulacaoFolha';
import OrcamentoDash from '../pages/orcamentoDash'
import Login from '../pages/login';
import Register from '../pages/registro';
import Inicio from '../pages/inicio'
import PainelExecutivo from '../pages/Dash/painelExecutivo'
import Pagamentos from '../pages/Dash/pagamentos'
import Recebimentos from '../pages/Dash/recebimento'
import PrivateRoute from '../PrivateRoute';
import GoogleFormFinanceiro from '../pages/formularioGp';
import TabelaLuciano from '../pages/dadosLuciano'
import Inadimplencia from '../pages/inadimplencia';
import ControleCompetencia from '../pages/competencia';
import FluxoCaixa from '../pages/fluxoCaixa';
export default function AppRoutes() {

  const rolesAtuais = [
    'admin', "RH", "TI", "ADMFIN", "NEGOCIOS", "EXECUTIVA",
    "VIAGENS", "FACILITIES", "COMERCIAL", "QUALIDADE", "JURIDICO",
    "OPERACAO", "MARKETING","GESTOR_ESTRATEGICO","PESSOA&CULTURA"
  ];

  const rolesCoordenadores = rolesAtuais.map(role => `COORDENADOR_${role}`);
  const todasRolesPermitidas = [...rolesAtuais, ...rolesCoordenadores];
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/cadastro" element={<Register />} />
      <Route
        path="/margem-bruta"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor', 'administracao', 'OPERACAO','ASSISTENTEOPERACAO','GESTOR_ESTRATEGICO']}>
            <MargemBruta />
          </PrivateRoute>
        }
      />
      <Route
        path="/margem-bruta-percentual"
        element={
          <PrivateRoute allowedRoles={['admin','HELIO']}>
            <MargemBrutaPercentual/>
          </PrivateRoute>
        }
      />
      <Route
        path="/salarios-por-projeto"
        element={
          <PrivateRoute allowedRoles={['admin', 'rh', 'financeiro', 'diretor']}>
            <SalariosPorProjeto />
          </PrivateRoute>
        }
      />

      <Route
        path="/custos-por-projeto"
        element={
          <PrivateRoute allowedRoles={['admin', 'rh', 'financeiro', 'diretor', 'administracao', 'OPERACAO','ASSISTENTEOPERACAO','GESTOR_ESTRATEGICO']}>
            <CustosPorProjeto />
          </PrivateRoute>
        }
      />

      <Route
        path="/simulacao-folha"
        element={
          <PrivateRoute allowedRoles={['admin', 'rh', 'financeiro', 'diretor', 'OPERACAO','GESTOR_ESTRATEGICO']}>
            <SimuladorFolha />
          </PrivateRoute>
        }
      />

      <Route
        path="/orcamento-dash"
        element={
          <PrivateRoute allowedRoles={todasRolesPermitidas}>
            <OrcamentoDash />
          </PrivateRoute>
        }
      />

      <Route
        path="/inicio"
        element={
          <PrivateRoute>
            <Inicio />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-executivo"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor']}>
            <PainelExecutivo />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-pagamentos"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor']}>
            <Pagamentos />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-recebimentos"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor']}>
            <Recebimentos />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-formulario"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor','GP']}>
            <GoogleFormFinanceiro />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-inadimplencia"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor','GP','GESTOR_ESTRATEGICO',"OPERACAO'"]}>
            <Inadimplencia />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-competencia"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor','GP','GESTOR_ESTRATEGICO','OPERACAO']}>
            <ControleCompetencia/>
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-inadimplencia-dash"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor']}>
            <Inadimplencia />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-competencia-dash"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor']}>
            <ControleCompetencia/>
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-fluxo-caixa-dash"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor']}>
            <FluxoCaixa/>
          </PrivateRoute>
        }
      />
      <Route
        path="/orcamento-operacao"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor', 'OPERACAO', 'ASSISTENTEOPERACAO']}>
            <TabelaLuciano />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}
